import iconPlus from 'assets/img/svg/plus.svg'
import iconMinus from 'assets/img/svg/minus.svg'
import mediasMixins from 'root/mixins/mediasMixin.js'
import facetsMixin from 'root/mixins/facetsMixin.js'

export default {
  name: 'facet-nav-refinement-facet',
  mixins: [mediasMixins,facetsMixin],
  props: [
    'accordionactive',
    'facetcode',
    'facetdata'
  ],
  data () {
    return {
      iconPlus: iconPlus,
      iconMinus: iconMinus,
      collapsed: true,
    }
  },

  methods: {
    clickAccordion (item) {
      this.$root.$emit('facet--accordion--item', item)
    },

    submitForm (e, q, text) {
      // e.target.form.submit()
      e.preventDefault()
      this.$root.$emit('show--spinner--category--page')
      var decodedUrl = e.target.form.action 
      var searchPageDataUrl = decodedUrl.split("?").length > 1 ? (decodedUrl.split("?")[0] + '/getsearchpagedata?' + decodedUrl.split("?")[1]) : decodedUrl + '/getsearchpagedata'
      this.$http.post(searchPageDataUrl, {
        CSRFToken: this.$root.CSRFToken
      },{ emulateJSON: true }).then(response => {
        this.updateFacetData(response)
      }, error => {
        this.isLoading = false
        console.error(error)
      }).finally(() => {
        this.$root.$emit('hide--spinner--category--page')
      })
      
    },

    isExist: function (item) {
      for (var i = 0; i < this.accordionactive.length; i++) {
        if (this.accordionactive[i] === item) {
          return true
        }
      }
      return false
    },

    toggleCollapse: function(){
      this.collapsed = !this.collapsed;
    }
  },

  computed: {
    facetDataComputed() {
      return this.isJson(this.facetdata)
    },
    facetData() {
      return this.facetdata
    },
    searchPageData() {
      return _.get(this, '$root.searchPageData')
    }
  },
  
  filters: {
    toUpperCase: function (value) {
      if (!value) return ''
      return value.toString().toUpperCase()
    }
  },
  mounted: function () {
    var $this = this
    var list = this.$el.getElementsByTagName('input')
    for (var i = 0; i < list.length; i++) {
      if (list[i].checked) {
        $this.$root.$emit('add--facet--accordion--item', $this.facetcode)
      }
    }
  },

  watch: {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/facetnavrefinementfacet/facetnavrefinementfacet.js